module.exports = __webpack_public_path__ + "Flag-218.d82ad847a22ee4247502de0dc9782c76.svg";